import React from 'react';
import _ from 'lodash';
import { SpotWorkerInputText } from '../SpotWorkerInputText.jsx';

import { FormElement, FormListItem } from '../../CommonFormComponents';
import { WORKER_IMAGE_CCUS_SYNCED_STATUS } from '../../../utilities/constants.js';

/**
 * 基本情報の顔写真情報
 * @param {object} spotWorkerInfo 現場常駐社員・非常駐入退場者情報
 */
export const SpotWorkerImageInfo = ({ spotWorkerInfo }) => {
  const imageInfo = spotWorkerInfo.worker_image_info;
  console.log(JSON.stringify(spotWorkerInfo));
  const formattedSyncedStatus =
    imageInfo.allCcusSyncedStatuses.length > 0 ? (
      imageInfo.allCcusSyncedStatuses.map((item, index) => (
        <p key={index}>{item.formatted}</p>
      ))
    ) : (
      <p>
        {
          _.find(WORKER_IMAGE_CCUS_SYNCED_STATUS, {
            id: imageInfo.ccusSyncedStatus,
          }).name
        }
      </p>
    );

  const formattedExclusionReason =
    spotWorkerInfo.worker_image_exclusion_reason !== '' ? (
      <p>{spotWorkerInfo.worker_image_exclusion_reason}</p>
    ) : (
      <p>ー</p>
    );

  const formattedErrors =
    imageInfo.allErrors.length > 0 && imageInfo.hasError ? (
      imageInfo.allErrors.map((item, index) => (
        <p key={index}>{item.formatted}</p>
      ))
    ) : (
      <p>ー</p>
    );

  return (
    <React.Fragment>
      <FormListItem label='顔写真送信' required={false}>
        <FormElement>
          <SpotWorkerInputText
            name='synced_status'
            value={formattedSyncedStatus}
            disabled={true}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='送信対象外理由' required={false}>
        <FormElement>
          <SpotWorkerInputText
            name='exclusion_reason'
            value={formattedExclusionReason}
            disabled={true}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='エラー状態' required={false}>
        <FormElement>
          <SpotWorkerInputText
            name='has_error'
            value={formattedErrors}
            disabled={true}
          />
        </FormElement>
      </FormListItem>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/form/SpotWorkerImageInfo.jsx